module.exports = __webpack_public_path__ + "static/media/boom.6959245f.png";